$(document).ready(function(){

    $(".section-slides").slick({
        dots: true,
        infinite: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
        autoplay:true,
        arrows:false,
        mobileFirst:true,
        pauseOnHover:true,
        centerMode: false,
        adaptiveHeight: false,
        focusOnSelect: false,
        variableWidth: false,
        responsive:[
            {
                breakpoint: 1200,
                settings: {
                    draggable:false
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".section-quotes").slick({
        dots: true,
        infinite: true,
        autoplaySpeed: 3000,
        speed: 500,
        autoplay:true,
        arrows:false,
        mobileFirst:true,
        pauseOnHover:true,
        centerMode: false,
        adaptiveHeight: false,
        focusOnSelect: false,
        variableWidth: false,
        responsive:[
            {
                breakpoint: 1200,
                settings: {
                    draggable:false,
                    arrows: true
                }
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    $(".section-posts").slick({
        dots: true,
        infinite: false,
        autoplaySpeed: 3000,
        speed: 500,
        autoplay: false,
        arrows: false,
        mobileFirst: true,
        pauseOnHover: true,
        centerMode: false,
        adaptiveHeight: true,
        focusOnSelect: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    draggable: false,
                    arrows: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

});
